<div class="container">
  @if(icon()){
    <mat-icon  [fontIcon]="icon()!" style="height: 22px; width:22px; font-weight: 900"/>
  }
  <span class="text-overflow">{{ firstPart() }}</span>
  <span> {{ lastWord() }}</span>
</div>
